import { noop } from 'lodash';
import type { Context } from 'react';
import { createContext } from 'react';

interface SuiteHeaderStatusContextProps {
  readonly isSuiteHeaderFinishedLoading: boolean;
  readonly setSuiteHeaderFinishedLoading: (isSuiteHeaderFinishedLoading: boolean) => void;
}

export const SuiteHeaderStatusContext: Context<SuiteHeaderStatusContextProps> =
  createContext<SuiteHeaderStatusContextProps>({
    isSuiteHeaderFinishedLoading: false,
    setSuiteHeaderFinishedLoading: noop,
  });
